module.exports = __webpack_public_path__ + "img/home-07-milestone-modal-bg-02.bcf94871.jpg";